<script setup>
import {defineProps, ref} from 'vue';
import axios from "axios";
import authHeader from "@/services/auth-header";

const props = defineProps(['url']);
const searchEntryInput = ref('');
const entries = ref({ entries: [] });
const page = ref(1);

function getEntriesData(value) {
  switch (value) {
    case '-1':
      if (page.value > 1) page.value -= 1;
      break;
    case '0':
      page.value = 1;
      break;
    case '+1':
      page.value += 1;
      break;
  }
  axios.post(props.url, { page: page.value, limit: 6 }, authHeader())
      .then(res => {
        entries.value.entries = res.data.items;
      })
      .catch(err => {
        console.error('Error fetching entries:', err);
      });
}

function searchEntries() {
  if (searchEntryInput.value.length > 0) {
    axios.post(props.url, { page: 1, limit: 1000 }, authHeader())
        .then(res => {
          entries.value.entries = res.data.items.filter(
              entry => entry.title.toLowerCase().includes(searchEntryInput.value.toLowerCase())
          );
        })
        .catch(err => {
          console.error('Error searching entries:', err);
        });
  } else {
    this.appStore.setIsAlert('Wpisz co najmniej 1 znak');
  }
}

function resetSearch() {
  searchEntryInput.value = '';
  getEntriesData('0');
}
</script>

<template>
  <div class="search-bar">
    <input
        type="text"
        placeholder="Wyszukaj..."
        v-model="searchEntryInput"
        @keyup.enter="searchEntries"
    >
    <button @click="searchEntries" class="btn-green">Szukaj</button>
    <button @click="resetSearch" class="btn-outline">Resetuj</button>
  </div>
</template>

<style scoped lang="scss">

</style>